/* Eloence Gift — 5 ml offert automatique (Reglages du theme > Éloence · Cadeau 5 ml).

   Des que le panier contient au moins « seuil » flacons 50 ml des parfums
   listes, une variante du produit cadeau (0,00 €) est ajoutee avec la
   propriete cachee _cadeau = "1" ; elle est retiree sous le seuil. Aucune
   remise Shopify n'intervient.

   Une ligne cadeau = une ligne du produit cadeau, qu'elle porte _cadeau ou
   non : une ligne qui aurait perdu la propriete est quand meme dedoublonnee.

   syncGift() est appelee par eloence-cart.js apres chaque ajout / changement
   de quantite / suppression, par eloence-ui.js a l'ouverture du tiroir, et
   par la page panier au chargement. Un seul appel en cours a la fois, au plus
   un en attente (voir syncGift).

   La decision (planGift) est une fonction pure, testee par
   node --test tests/gift.test.js */
(function (root) {
  'use strict';

  /* « Ombre d’Encens » == « Ombre d'Encens » == « ombre dencens » */
  function norm(s) {
    return String(s == null ? '' : s)
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  function sameName(a, b) {
    var x = norm(a);
    var y = norm(b);
    return !!x && !!y && (x === y || x.indexOf(y) >= 0 || y.indexOf(x) >= 0);
  }

  /* Associe chaque parfum a sa variante cadeau et au prix de son 5 ml payant.
     Un parfum sans 50 ml, sans variante cadeau ou sans 5 ml payant associe est
     signale dans `unmatched` et ne peut pas etre offert. */
  function buildModel(config) {
    var unmatched = [];
    var perfumes = (config.perfumes || []).map(function (p) {
      var gift = null;
      var paidPrice = null;
      (config.gifts || []).forEach(function (g) {
        if (!gift && sameName(g.title, p.name)) gift = { variantId: g.variantId, available: !!g.available, title: g.title };
      });
      (config.paid || []).forEach(function (s) {
        if (paidPrice == null && sameName(s.name, p.name)) paidPrice = s.price;
      });
      if (!p.variantId) unmatched.push(p.name + ' : pas de variante 50 ml');
      if (!gift) unmatched.push(p.name + ' : pas de variante cadeau');
      if (paidPrice == null) unmatched.push(p.name + ' : pas de 5 ml payant');
      return { name: p.name, productId: p.productId, variantId: p.variantId, image: p.image || null, gift: gift, paidPrice: paidPrice };
    });
    return {
      giftProductId: config.giftProductId,
      threshold: config.threshold || 2,
      perfumes: perfumes,
      unmatched: unmatched,
    };
  }

  function perfumeIndexByBottle(model, variantId) {
    for (var i = 0; i < model.perfumes.length; i++) {
      if (model.perfumes[i].variantId && model.perfumes[i].variantId === variantId) return i;
    }
    return -1;
  }

  function perfumeIndexByGift(model, variantId) {
    for (var i = 0; i < model.perfumes.length; i++) {
      if (model.perfumes[i].gift && model.perfumes[i].gift.variantId === variantId) return i;
    }
    return -1;
  }

  function isGiftLine(model, item) {
    return !!item && item.product_id === model.giftProductId;
  }

  /* Flacons 50 ml des parfums listes. Les 5 ml payants et le cadeau ne
     comptent pas. */
  function bottleCount(model, items) {
    var n = 0;
    (items || []).forEach(function (it) {
      if (isGiftLine(model, it)) return;
      if (perfumeIndexByBottle(model, it.variant_id) >= 0) n += it.quantity;
    });
    return n;
  }

  /* Decision pure a partir des lignes de /cart.js.
     -> { type: 'none' }
     -> { type: 'add', variantId }
     -> { type: 'update', updates: { <cle de ligne>: quantite } } */
  function planGift(model, items) {
    items = items || [];
    var count = bottleCount(model, items);
    var giftLines = items.filter(function (it) { return isGiftLine(model, it); });

    if (count < model.threshold) {
      if (!giftLines.length) return { type: 'none' };
      var off = {};
      giftLines.forEach(function (l) { off[l.key] = 0; });
      return { type: 'update', updates: off };
    }

    if (giftLines.length) {
      var fix = {};
      var dirty = false;
      if (giftLines[0].quantity > 1) { fix[giftLines[0].key] = 1; dirty = true; }
      for (var k = 1; k < giftLines.length; k++) { fix[giftLines[k].key] = 0; dirty = true; }
      return dirty ? { type: 'update', updates: fix } : { type: 'none' };
    }

    /* Parfum par defaut : le premier des parfums absent du panier ; si tous y
       sont, celui de la premiere ligne flacon. Puis les autres, dans l'ordre,
       pour sauter une variante cadeau epuisee. */
    var present = {};
    var firstLine = -1;
    items.forEach(function (it) {
      if (isGiftLine(model, it)) return;
      var idx = perfumeIndexByBottle(model, it.variant_id);
      if (idx < 0) return;
      present[idx] = true;
      if (firstLine < 0) firstLine = idx;
    });
    var order = [];
    model.perfumes.forEach(function (p, i) { if (!present[i]) order.push(i); });
    if (!order.length && firstLine >= 0) order.push(firstLine);
    model.perfumes.forEach(function (p, i) { if (order.indexOf(i) < 0) order.push(i); });

    for (var o = 0; o < order.length; o++) {
      var g = model.perfumes[order[o]].gift;
      if (g && g.available) return { type: 'add', variantId: g.variantId };
    }
    return { type: 'none' };
  }

  var api = {
    norm: norm,
    buildModel: buildModel,
    planGift: planGift,
    bottleCount: bottleCount,
    isGiftLine: isGiftLine,
    perfumeIndexByGift: perfumeIndexByGift,
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }

  /* ---------- Reseau ---------- */

  var configEl = document.getElementById('el-gift-config');
  if (!configEl) return;
  var model;
  try { model = buildModel(JSON.parse(configEl.textContent)); } catch (e) { return; }
  if (model.unmatched.length && window.console) console.warn('[eloence-gift] association incomplete :', model.unmatched);

  function debug(e) {
    if (window.console && console.debug) console.debug('[eloence-gift]', e);
  }

  function request(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var err = new Error((data && (data.description || data.message)) || ('Gift request failed: ' + r.status));
          err.status = r.status;
          throw err;
        }
        return data;
      });
    });
  }

  /* Pose le panier recu en un seul rendu. */
  function commit(cart) {
    if (window.ELOENCE_CART && typeof window.ELOENCE_CART._setState === 'function') {
      window.ELOENCE_CART._setState(cart);
    }
    return cart;
  }

  function addGift(variantId) {
    return request('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _cadeau: '1' } }] })
      .then(function () { return request('/cart.js'); });
  }

  function runOnce() {
    return request('/cart.js').then(function (cart) {
      var plan = planGift(model, cart.items);
      if (plan.type === 'add') {
        return addGift(plan.variantId).then(function (c) { commit(c); return { changed: true, cart: c }; });
      }
      if (plan.type === 'update') {
        return request('/cart/update.js', { updates: plan.updates }).then(function (c) { commit(c); return { changed: true, cart: c }; });
      }
      return { changed: false, cart: cart };
    });
  }

  /* Verrou : toutes les operations cadeau passent par une file unique, donc
     un seul appel reseau cadeau a la fois. Une synchro demandee alors qu'une
     autre attend deja son tour reutilise celle-ci : au plus une en cours et
     une en attente, jamais de boucle. Un echec s'arrete la, sans nouvel essai. */
  var chain = Promise.resolve();
  var queuedSync = null;

  function settle(task) {
    return function () {
      return task().catch(function (err) { debug(err); return { changed: false, error: err }; });
    };
  }

  function syncGift() {
    if (queuedSync) return queuedSync;
    var p = chain.then(function () { queuedSync = null; }).then(settle(runOnce));
    queuedSync = p;
    chain = p;
    return p;
  }

  /* Changement de parfum du cadeau. /cart/update.js ne sait pas poser de
     proprietes : on ajoute la nouvelle variante avec _cadeau, puis on passe
     l'ancienne ligne a 0, dans la meme file, et on rend une seule fois. */
  function swapGift(newVariantId) {
    var p = chain.then(settle(function () {
      return request('/cart.js').then(function (cart) {
        var lines = cart.items.filter(function (it) { return isGiftLine(model, it); });
        if (!lines.length || lines[0].variant_id === newVariantId) return { changed: false, cart: cart };
        var oldKey = lines[0].key;
        return request('/cart/add.js', { items: [{ id: newVariantId, quantity: 1, properties: { _cadeau: '1' } }] })
          .then(function () { return request('/cart/change.js', { id: oldKey, quantity: 0 }); })
          .then(function (c) { commit(c); return { changed: true, cart: c }; });
      });
    }));
    chain = p;
    return p;
  }

  /* Pour les rendus (tiroir, page panier). */
  function lineInfo(item) {
    if (!isGiftLine(model, item)) return null;
    var idx = perfumeIndexByGift(model, item.variant_id);
    return {
      perfumeIndex: idx,
      paidPrice: idx >= 0 ? model.perfumes[idx].paidPrice : null,
      /* Le produit cadeau peut ne pas avoir de photo : celle du parfum sert. */
      image: idx >= 0 ? model.perfumes[idx].image : null,
    };
  }

  function choices() {
    return model.perfumes
      .map(function (p) { return p.gift ? { variantId: p.gift.variantId, name: p.name, available: p.gift.available } : null; })
      .filter(Boolean);
  }

  var labels = (function () {
    try { return JSON.parse(configEl.textContent).labels || {}; } catch (e) { return {}; }
  })();

  root.ELOENCE_GIFT = {
    sync: syncGift,
    swap: swapGift,
    lineInfo: lineInfo,
    choices: choices,
    bottleCount: function (items) { return bottleCount(model, items); },
    isGiftLine: function (item) { return isGiftLine(model, item); },
    labels: labels,
    model: model,
  };
})(typeof window !== 'undefined' ? window : this);
